import styled from 'styled-components'

const Svg = styled.svg`
  &.svg-inline--fa.fa-w-18 {
    width: 1.125em;
  }

  &.svg-inline--fa {
    display: inline-block;
    font-size: inherit;
    height: 1em;
    overflow: visible;
    vertical-align: -0.125em;
  }
`

export default Svg
